/**
 * Согласованный стек наложения панелей главного map-workspace (home).
 * Баннер режима рисования — поверх карты, но ниже модалок.
 * DrawingPanel / floating ObjectPanel — выше правых overlay (кадастр/OSM).
 * Dialog / AlertDialog / Select в модалках — выше панелей.
 */

export const MAP_PANEL_Z = {
  /** CadastreSearchPanel / OsmReviewPanel (правая полоса) */
  sideOverlay: "z-40",
  /** MapDrawingModeBanner */
  drawingBanner: "z-[150]",
  /** DrawingPanel, floating ObjectPanel */
  mapPanel: "z-[200]",
  /** AlertDialog / Dialog (см. ui/dialog, ui/alert-dialog) */
  dialog: "z-[220]",
  /** SelectContent внутри модалок */
  dialogSelect: "z-[250]",
} as const;
